let _offsetFn = null;
export function getOffset() {
    if (_offsetFn) {
        return _offsetFn();
    }
    else {
        return 0;
    }
}
export function registerOffsetFn(fn) {
    _offsetFn = fn;
}
export function getNowMs() {
    // eslint-disable-next-line
    return Date.now() + getOffset();
}
//# sourceMappingURL=RooTimeService.js.map